// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"eeae8091","787":"42c3c54b"}[chunkId] + ".chunk.js";
};